import { createFileRoute } from '@tanstack/react-router';
import { PublicKnowledgeBase } from '../../../../../customer-portal/pages/PublicKnowledgeBase';
import { usePortalContext } from '../../../../../contexts/PortalContext';
import { z } from 'zod';

const knowledgeBaseSearchSchema = z.object({
  // A collection or section id
  collection: z.string().optional(),
  // Links from before the knowledge base moved to collections (?category=) - collections kept those ids
  category: z.string().optional(),
  search: z.string().optional(),
});

function PortalKnowledgeBaseIndex() {
  const { organizationInfo } = usePortalContext();
  const search = Route.useSearch();
  
  return (
    <PublicKnowledgeBase 
      organizationInfo={organizationInfo}
      organizationId={organizationInfo.organizationId}
      collectionFilter={search.collection ?? search.category}
      searchFilter={search.search}
    />
  );
}

export const Route = createFileRoute('/org/$orgSlug/portal/knowledge-base/')({
  component: PortalKnowledgeBaseIndex,
  validateSearch: knowledgeBaseSearchSchema,
});